import React from "react";
import { Link } from "react-router-dom";
import logo from "images/CryptoWall-logo.png"

export interface LogoProps {
  img?: string;
  imgLight?: string;
}

const Logo: React.FC<LogoProps> = () => {
  return (
    <Link to="/" className="ttnc-logo inline-block text-primary-6000">
      <img src={logo} alt="CryptoVerse" />
    </Link>
  );
};

export default Logo;
